<template>
  <main class="auth-page">
    <section class="auth-card" aria-labelledby="recover-title">
      <header class="auth-header">
        <img src="@/assets/images/lengedu.jpg" alt="Lengedu" class="auth-logo">
        <span class="auth-eyebrow">YENİ BİR BAŞLANGIÇ</span>
        <h1 id="recover-title">Yeni parolanızı belirleyin</h1>
        <p>Hesabınıza yeniden erişmek için yeni parolanızı oluşturun.</p>
      </header>
      <form class="auth-form" @submit.prevent="submit" :aria-busy="form.isLoading">
        <div class="auth-field">
          <label for="password">Yeni parola</label>
          <input id="password" v-model="form.password" type="password" placeholder="Yeni parolanızı girin" autocomplete="new-password" inputmode="numeric" aria-describedby="password-hint" :disabled="form.isLoading" required>
          <p id="password-hint" class="auth-hint">Parolanız yalnızca rakamlardan ve 4–8 karakterden oluşmalıdır.</p>
        </div>
        <div class="auth-field">
          <label for="passwordconfirm">Yeni parola tekrar</label>
          <input id="passwordconfirm" v-model="form.passwordConfirm" type="password" placeholder="Yeni parolanızı tekrar girin" autocomplete="new-password" inputmode="numeric" :disabled="form.isLoading" required>
        </div>
        <button class="auth-submit" type="submit" :disabled="form.isLoading">
          <span v-if="form.isLoading" class="auth-spinner" aria-hidden="true"></span>
          <span aria-live="polite">{{ form.isLoading ? 'Kaydediliyor…' : 'Parolayı güncelle' }}</span>
        </button>
      </form>
      <p class="auth-register"><router-link to="/login"><span aria-hidden="true">← </span>Giriş sayfasına dön</router-link></p>
    </section>
    <footer class="auth-footer"><VersionNumber /></footer>
  </main>
</template>

<script>
  import { mapActions } from "vuex";
  import VersionNumber from "@/components/Shared/VersionNumber.vue";
  import { LoadingToast,UpdateToast,ToastType,ErrorToast } from "@/common/notification.js";
  import {IsPasswordValid} from "@/common/validation-password";
  export default {
    name: "RecoverPasswordPage",
    components: {
      VersionNumber
    },
    data() {
      return {
        form: {
          password: "",
          passwordConfirm: "",
          code:this.$route.params.code,
          isLoading:false
        }
      };
    },
    methods: {
      ...mapActions(["SavePassword"]),
      async submit() {
        if (this.form.isLoading) return;
        if(!this.isFormValid()){
          return;
        }

        let toastId = LoadingToast();
        this.form.isLoading=true;
        const formModel = {
          "SecureCode": this.form.code,
          "Password": this.form.password,
          "PanelType": 2
        };
        await this.SavePassword(formModel)
        .then((res)=>{
          this.form.isLoading=false;
          UpdateToast(toastId,res.description,ToastType().SUCCESS);
          setTimeout(() => {
            this.$router.push("/");  
          }, 1000);
        })
        .catch(err=>{
          UpdateToast(toastId,err.message,ToastType().ERROR);
          this.form.isLoading=false;
        });
      },
      isFormValid(){
        if (this.form.password.length < 4 || this.form.password.length>8) {
            ErrorToast('Parolanız en az 4 en fazla 8 karakterden oluşmalıdır.');
            return false;
        }
        if (!IsPasswordValid(this.form.password)) {
            ErrorToast('Hatalı parola girdiniz.');
            return false;
        }
        if (this.form.password !== this.form.passwordConfirm) {
            ErrorToast('Parolanızı onaylayınız.');
            return false;
        }

        return true
      }
    }
  };
  </script>

<style scoped src="@/assets/styles/auth.css"></style>
